<template>
    <div v-loading="isSuccess" class="MCourseView"
         :class="courseData.isjoin === 1 && (active === 0 || active === 1)  ? 'padding0' : ''">
         <!-- 董秘APP内嵌提示 -->
        <div class="dmAppTips" v-if="showAppTips">
            <div class="leftTips">
                <img @click="showAppTips = false" :src="require('@/common/images/mobile/close.png')" class="closeIcon" alt="">
                <img v-if="appType === 'appByDM'" :src="require('@/common/images/common/dm_logo.png')" class="logo" alt="">
                <img v-if="appType === 'appByZJ'" :src="require('@/common/images/common/zj_logo.png')" class="logo" alt="">
                <div class="text">打开{{appType === 'appByDM' ? '董秘' : '资鲸'}}APP，查看更多课程</div>
            </div>
            <!-- <div class="rightOpenApp" @click="openApp">立即打开</div> -->
            <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'iOS' && appType === 'appByDM'" :href="'https://www.capwhale.com/ulink/iosdmapp/course/courseDetails/courseDetails?courseid=' + courseData.courseid" class="rightOpenApp">立即打开</a>
            <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'iOS' && appType === 'appByZJ'" :href="'https://www.capwhale.com/ulink/ioscapwhale/course/course-details?courseid=' + courseData.courseid" class="rightOpenApp">立即打开</a>
            <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'android' && appType === 'appByDM'" :href="'dmapp://course/courseDetails/courseDetails?courseid=' + courseData.courseid" class="rightOpenApp">立即打开</a>
            <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'android' && appType === 'appByZJ'" :href="'zjapp://course/course-details?courseid=' + courseData.courseid" class="rightOpenApp">立即打开</a>
            <div class="wechatOpenApp" v-if="_isWixin() && mobilePhoneType === 'android'">
                <wx-open-launch-app id="launch-btn" appid="wx04d8952d30352373" @error="handlewxOpenApperror"
                  :extinfo="appType === 'appByDM' ? 'dmapp://course/courseDetails/courseDetails?courseid=' + courseData.courseid : 'zjapp://course/course-details?courseid=' + courseData.courseid" 
                  style="position:absolute;top:0;right:0;width: 100%;height: 0.9rem;zIndex: 1000;display: flex;alignItems: center;justifyConent: center">
                  <script type="text/wxtag-template">
                      <style>.btn { padding: 14px 50px;color: transparent;text-align: center;background: transparent;border: none;display: block;}</style>
                      <button class="btn">立即打开</button>
                  </script>
              </wx-open-launch-app>
            </div>
          </div>
        <div class="course_top_box">
            <img v-show="taskInfoData.kmctype === ''" :src="courseData.coverurl" alt="">
            <img v-show="(taskInfoData.kmctype === 6)" :src="taskInfoData.coverurl ? taskInfoData.coverurl : courseData.coverurl" alt="">
            <img v-show="taskInfoData.kmctype === 4 && playType==2" :src="courseData.coverurl" alt="">
            <div v-loading="pdfLoading" v-if="taskInfoData.kmctype === 2 && taskInfoData.reportimageinfo.length === 0"
                 class="curriculum_report_pdf_box">
                <pdf :src="taskInfoData.fullfileurl" :page="currentPage"></pdf>
                <img @click="changePdfPage(0)" class="img_icon left_img_icon"
                     :src="require('@/common/images/other/icon_left.png')" alt="">
                <img @click="changePdfPage(1)" class="img_icon right_img_icon"
                     :src="require('@/common/images/other/icon_right.png')" alt="">
                <div class="bottom_div">
                    <span>电子书</span>
                    <span>{{currentPage}} / {{pageCount}} 页</span>
                    <img @click="toReportPrview" :src="require('@/common/images/other/icon_full.png')" alt="">
                </div>
            </div>
            <div v-if="taskInfoData.kmctype === 2 && taskInfoData.reportimageinfo.length > 0" class="curriculum_report">
                <img @click="imgPreview(taskInfoData.reportimageinfo)" :src="currentReportImg" alt="">
                <div class="top">
                    <div :class="reportImgPage === item.reportimageindex ? 'active' : ''"
                         v-for="(item, index) in taskInfoData.reportimageinfo" :key="index">
                        <img @click="reportImgClick(item)" :src="item.reportimageurl" alt="">
                    </div>
                </div>
                <div class="bottom">
                    <span>电子书</span>
                    <span>{{reportImgPage}} / {{taskInfoData.reportimageinfo.length}} 页</span>
                    <!-- <img @click="isFullScreenClick(true)" :src="require('@/common/images/mmy/icon_write.png')" alt=""> -->
                </div>
            </div>
            <div v-if="taskInfoData.kmctype === 4" class="curriculum_video">
                <courseVideoPlayer ref="courseVideoPlayer" :taskInfoData="taskInfoData" :playType="playType" :courseData="courseData"></courseVideoPlayer>
            </div>
            <div v-if="taskInfoData.kmctype === 6" class="curriculum_audio">
                <CourseAudioPlayer ref="courseAudioPlayer" :audioUrl="taskInfoData.audiofurl"></CourseAudioPlayer>
            </div>
        </div>
        <div class="video-btns" v-if="(taskInfoData.kmctype === 4)&&(taskInfoData.audiofurl || taskInfoData.isspeedplay)">
            <span class="video-btn" v-if="taskInfoData.audiofurl" @click="toChangePlay">{{playType==1?'转音频':'转视频'}}</span>
            <span class="video-btn" @click="setFullScreen">全屏</span>
            <span class="video-btn" @click="handlePlaySpeed" v-if="taskInfoData.isfinishstudy || taskInfoData.isspeedplay">倍速{{playbackRate.toFixed(1)}}X</span>
        </div>
        <div class="limit-box" v-if="courseData.islimitcount && (!courseData.zjmemtype || (courseData.zjmemtype && courseData.plusprice > courseData.saleprice))">
            <div class="left">
                <div>
                    <span class="tagname">{{courseData.tagname?courseData.tagname:'限时秒杀价'}}</span>
                </div>
                <div class="price-box">
                    <span class="saleprice">￥{{courseData.saleprice}}</span>
                    <span class="uprice" v-if="courseData.uprice">￥{{courseData.uprice}}</span>
                </div>
            </div>
            <div class="right">
                <div class="tip">距结束仅剩</div>
                <div class="timer-box">
                    <span class="sepa-r" v-if="timer.day">{{timer.day}}天</span>
                    <span class="time-box sepa-l sepa-r">{{timer.hour}}</span>:
                    <span class="time-box sepa-l sepa-r">{{timer.minute}}</span>:
                    <span class="time-box sepa-l">{{timer.second}}</span>
                </div>
            </div>
        </div>
        <div class="course_second_info" :class="{marginBottom20: !(courseData.couponvoucherlist && courseData.couponvoucherlist.length)}">
          <div class="price_collect" v-if="!courseData.islimitcount || (courseData.islimitcount && courseData.zjmemtype && courseData.plusprice < courseData.saleprice)">
              <div class="price">
                  <span class="saleprice" v-if="courseData.feetype === 1">免费</span>
                  <span class="saleprice" v-if="courseData.feetype === 2 && (!courseData.zjmemtype || (courseData.zjmemtype === 2 && courseData.plusprice == 0))"><span class="unit">￥</span>{{ courseData.saleprice }}</span>
                  <span class="uprice" v-if="courseData.feetype === 2 && courseData.uprice !== '0.00' && (!courseData.zjmemtype || (courseData.zjmemtype === 2 && courseData.plusprice == 0))">¥{{courseData.uprice}}</span>
                  <div class="div_price" v-if="courseData.feetype === 2 && courseData.zjmemtype && !user.zjmemtype && courseData.plusprice > 0">
                      <div class="saleprice"><span class="unit">￥</span>{{courseData.saleprice}}</div>
                      <img :src="require('@/common/images/course/plus_price_icon1_mobile.png')" class="plusPriceIcon1" alt="">
                      <span class="plusPrice">￥{{ courseData.plusprice }}</span>
                  </div>
                  <div class="div_price" v-if="courseData.feetype === 2 && courseData.zjmemtype && user.zjmemtype && courseData.plusprice > 0">
                      <div class="saleprice"><span class="unit">￥</span>{{courseData.plusprice}}</div>
                      <img :src="require('@/common/images/course/plus_price_icon2_mobile.png')" class="plusPriceIcon2" alt="">
                      <span class="plusPrice">原价：￥{{ courseData.saleprice }}</span>
                  </div>
              </div>
              <div class="collect" @click="enshrineClick(courseData.isfavorite)">
                <img class="collect_icon" :src="courseData.isfavorite === 1 ? require('@/common/images/mmy/enshrine.png') : require('@/common/images/mmy/no_enshrine.png')" alt="">
                <span class="collect_text" :class="courseData.isfavorite === 1 ? 'yellow_text' : ''">{{courseData.isfavorite === 0 ? '收藏' : '取消'}}</span>
              </div>
          </div>
          <div class="course_subject_box" id="courseSubjectBox">
            <div class="subject" id="subjectDiv" :class="{inline: !subjectIsPackup}">
                {{ courseData.subject }}
                <div class="handleIconBox" :class="{packup: subjectIsPackup}" @click="handleChangeSubjectIsPackup" v-if="showSubjectHandle">
                  <img class="subjectHandle" :src="require('@/common/images/course/unfold_packup.png')" />
                </div>
            </div>
          </div>
          <div class="memberTips" @click="handleGoMemberDetails">
              <div class="iconTips">
                  <img :src="require('@/common/images/course/member_icon_mobile.png')" class="memberIcon" alt="">
                  <div class="tips">加入蓝鲸会员享受更多权益！</div>
              </div>
              <img :src="require('@/common/images/course/arrow_icon_mobile.png')" class="arrowIcon" alt="">
          </div>
        </div>
        <div class="coupon_box" v-if="courseData.couponvoucherlist && courseData.couponvoucherlist.length">
            <div class="coupon" @click="openGetCoupon">
                <div class="left">
                    <div class="name">优惠</div>
                    <div class="get_coupon">领券</div> 
                    <div class="item" :class="{'theSecond': index === 1}" v-for="(item, index) in courseData.couponvoucherlist" :key="index" v-show="index < 2">{{item.prefercontent}}</div>
                </div>
                <div class="right">
                    <img :src="require('@/common/images/mmy/icon-arrow-right.png')" alt="">
                </div>
            </div>
        </div>
        <div @click="toOrganPage" class="organ_box margin_bottom20">
            <div>
                <img :src="courseData.hostinfo.hostlogourl" alt="">
                <div>
                    <p>{{courseData.hostinfo.hostname}}</p>
                    <!-- <p>
                        课程数{{courseData.hostinfo.coursecount}}｜学生数{{courseData.hostinfo.studentcount}}｜好评度{{courseData.hostinfo.feedback}}%</p> -->
                </div>
            </div>
            <img :src="require('@/common/images/mmy/icon-arrow-right.png')" alt="">
        </div>
        <div class="course_tabs_box">
            <van-tabs @change="tabChange" sticky v-model="active" animated line-height="2" line-width="25"
                      color="#409EFF" title-inactive-color="#333" title-active-color="#409EFF">
                <van-tab v-for="(tabitem,index) in tabsName" :key="index" :title="tabitem">
                    <div v-if="tabitem=='目录'" class="catalogue_warp tabs_item_box">
                        <div v-if="chapterData.length > 0">
                            <!-- 自由模式 -->
                            <div v-if="courseData.sectionunlocktype === 1" class="catalogue_content free_schema">
                                <van-collapse v-model="activeNames">
                                    <van-collapse-item v-for="(item, index) in chapterData" :key="index" :name="index">
                                        <div slot="title"><span>{{item.sectionname}}</span></div>
                                        <div v-if="item.taskinfolist.length > 0">
                                            <div @click="freeModeCourseTaskClick(subItem, courseData.isjoin)"
                                                 v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex"
                                                 :class="{'chapter_item_disabled': subItem.istry === '0' && courseData.isjoin === 0, 'is_active': taskid === subItem.innerid}"
                                                 class="chapter_item">
                                                <div class="left">
                                                    <label class="task_tag">{{tagText(subItem.kmctypename)}}</label>
                                                    <span>{{subItem.taskname}}</span>
                                                </div>
                                                <div class="right" v-if="taskid !== subItem.innerid">
                                                    <label v-if="subItem.istry === '1'" class="try_tag">试看</label>
                                                    <img v-if="subItem.istry === '0' && courseData.isjoin === 1"
                                                         :src="require('@/common/images/other/play_icon.png')" alt="">
                                                    <img v-if="subItem.istry === '0' && courseData.isjoin === 0"
                                                         :src="require('@/common/images/other/lock.png')" alt="">
                                                </div>
                                                <div class="right" v-if="taskid === subItem.innerid">
                                                    <img src="data:image/gif;base64,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">
                                                </div>
                                            </div>
                                        </div>
                                        <p v-if="item.taskinfolist.length === 0" class="no_content">暂无内容</p>
                                    </van-collapse-item>
                                </van-collapse>
                            </div>
                            <!-- 解锁模式 -->
                            <div v-if="courseData.sectionunlocktype === 2" class="catalogue_content">
                                <van-collapse v-model="activeNames">
                                    <van-collapse-item v-for="(item, index) in chapterData" :key="index" :name="index">
                                        <div slot="title">
                                            <span>{{item.sectionname}}</span><span>{{item.datetime}}</span></div>
                                        <div @click="UnlockPatternClick(subItem, courseData.isjoin)"
                                             v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex"
                                             :class="{'chapter_item_disabled': (subItem.istry === '0' && subItem.isunlock === 0) || (courseData.isjoin === 0 && subItem.istry === '0'), 'is_active': taskid === subItem.innerid}"
                                             class="chapter_item">
                                            <div class="left">
                                                <label class="task_tag">{{tagText(subItem.kmctypename)}}</label>
                                                <span>{{subItem.taskname}}</span>
                                            </div>
                                            <div class="right" v-if="taskid !== subItem.innerid">
                                                <label v-if="subItem.istry === '1'" class="try_tag">试看</label>
                                                <img v-if="subItem.istry === '0' && courseData.isjoin === 1 && subItem.isunlock === 1"
                                                     :src="require('@/common/images/other/play_icon.png')" alt="">
                                                <img v-if="(subItem.istry === '0' && subItem.isunlock === 0) || (courseData.isjoin === 0 && subItem.istry === '0')"
                                                     :src="require('@/common/images/other/lock.png')" alt="">
                                            </div>
                                            <div class="right" v-if="taskid === subItem.innerid">
                                                <img src="data:image/gif;base64,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">
                                            </div>
                                        </div>
                                        <p v-if="item.taskinfolist.length === 0" class="no_content">暂无内容</p>
                                    </van-collapse-item>
                                </van-collapse>
                            </div>
                        </div>
                        <div v-if="chapterData.length === 0" class="no_data_box">
                            <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
                            <p>当前课程暂无目录</p>
                        </div>
                    </div>
                    <div v-if="tabitem=='详情'" class="details_warp tabs_item_box">
                        <div class="course_info_box margin_bottom20">
                            <!-- <div class="course_info">
                                <div class="course_info_left_box">
                                    <p>{{courseData.subject}}</p>
                                    <p>
                                        <el-rate v-if="courseData.commentcount>1" v-model="courseData.evaluatecount"
                                                disabled></el-rate>
                                        <span v-if="courseData.commentcount>1">{{courseData.evaluatecount}}分</span>
                                    </p>
                                </div>
                                <div @click="enshrineClick(courseData.isfavorite)" class="course_info_right_box">
                                    <img :src="courseData.isfavorite === 1 ? require('@/common/images/mmy/enshrine.png') : require('@/common/images/mmy/no_enshrine.png')"
                                        alt="">
                                    <span :class="courseData.isfavorite === 1 ? 'yellow_text' : ''">{{courseData.isfavorite === 0 ? '收藏' : '取消'}}</span>
                                </div>
                            </div> -->
                        </div>
                        <!-- <div @click="toEvaPage" class="evaluate_box margin_bottom20">
                            <p>课程评价({{courseData.commentcount-1}})</p>
                            <p>
                                <a v-if="courseData.commentcount>1">好评度{{courseData.goodcommentrate}}%</a>
                                <img :src="require('@/common/images/mmy/icon-arrow-right.png')" alt="">
                            </p>
                        </div> -->
                        <div v-if="courseData.content !== ''" class="course_details_div"
                             v-html="courseData.content"></div>
                        <div v-if="courseData.content === ''" class="no_data_box">
                            <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
                            <p>当前课程暂无详情</p>
                        </div>
                    </div>
                    <div v-if="tabitem=='讨论'" class="comment_warp tabs_item_box">
                        <div v-if="courseDiscussData.length > 0" class="comment_list_box">
                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                <van-list v-model="loading" :finished="finished" finished-text="— 已加载全部数据 —"
                                          @load="onLoad">
                                    <div class="comment_item_box" v-for="(item, index) in courseDiscussData"
                                         :key="index">
                                        <div>
                                            <img :src="item.customeratturl === ' ' || !item.customeratturl ? require('@/common/images/header/user.png') : item.customeratturl"
                                                 alt="">
                                            <div>
                                                <p class="name_text">{{item.customername}}</p>
                                                <p class="date_text">{{item.datetime}}</p>
                                            </div>
                                        </div>
                                        <p>{{item.content}}</p>
                                    </div>
                                </van-list>
                            </van-pull-refresh>
                        </div>
                        <div v-if="courseDiscussData.length === 0" class="no_data_box">
                            <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
                            <p>当前课程暂无讨论</p>
                        </div>
                    </div>
                    <div v-if="tabitem=='笔记'" class="notes_warp tabs_item_box">
                        <van-sticky offset-top="30">
                            <div class="notes_select_tabs">
                                <div @click="isAllNotesClick(1)" :class="isAllNotes===1?'notes_active':''">全部笔记</div>
                                <div @click="isAllNotesClick(2)" :class="isAllNotes===2?'notes_active':''">我的笔记</div>
                            </div>
                        </van-sticky>
                        <div class="notes_list_box">
                            <AllNotes v-show="isAllNotes === 1" :allNotesData="allNotesData"
                                      ref="allNotesRef"></AllNotes>
                            <MyNotes v-show="isAllNotes === 2" :myNotesData="myNotesData" ref="myNotesRef"></MyNotes>
                        </div>
                    </div>
                    <div v-if="tabitem=='资料'" class="notes_warp tabs_item_box">
                        <dataList ref="dataList" :item="courseData"></dataList>
                    </div>
                    <div v-if="tabitem=='题库'" class="ques_warp tabs_item_box">
                      <div class="quesItemBox">
                        <div class="quesItem" @click="handleGoQbDetails(item)" v-for="(item, index) in courseData.relqblist" :key="index">
                            {{item.subject}}
                        </div>
                      </div>
                      <div class="tips">没有更多了～</div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <div class="bottom_warp">
            <div v-if="courseData.isjoin === 0" class="box1">
                <van-button @click="joinCourseBtn" v-if="courseData.feetype === 1" type="primary">免费参与</van-button>
                <van-button @click="handleGoMemberDetails" v-if="courseData.feetype === 2 && courseData.zjmemtype && !user.zjmemtype && courseData.plusprice > 0 && (!courseData.islimitcount || (courseData.islimitcount && courseData.plusprice < courseData.saleprice))" type="warning openMember">开通PLUS会员</van-button>
                <van-button @click="handleGoMemberDetails" v-if="courseData.feetype === 2 && courseData.zjmemtype && user.zjmemtype === 1 && courseData.plusprice > 0 && (!courseData.islimitcount || (courseData.islimitcount && courseData.plusprice < courseData.saleprice))" type="warning upgrade">升级蓝鲸年卡</van-button>
                <van-button @click="handleGoMemberDetails" v-if="courseData.feetype === 2 && courseData.zjmemtype === 2 && courseData.plusprice == 0 && (!courseData.islimitcount || (courseData.islimitcount && courseData.plusprice < courseData.saleprice))" type="warning upgrade">开通蓝鲸年卡</van-button>
                <van-button @click="buyCourseBtn" v-if="courseData.feetype === 2 && ((courseData.zjmemtype && (!user.zjmemtype || user.zjmemtype === 1) && !courseData.islimitcount) || ((!user.zjmemtype || user.zjmemtype === 1) && courseData.zjmemtype && courseData.islimitcount && courseData.plusprice < courseData.saleprice) || (courseData.zjmemtype === 2 && courseData.plusprice == 0 && (!courseData.islimitcount || (courseData.islimitcount && courseData.plusprice < courseData.saleprice))))" type="primary" class="borderRadius">直接购买</van-button>
                <van-button @click="buyCourseBtn" v-else-if="courseData.feetype === 2 && (!courseData.zjmemtype || (courseData.zjmemtype === 1 && user.zjmemtype === 1) || (courseData.zjmemtype === 1 && user.zjmemtype === 2) || (courseData.islimitcount && courseData.plusprice > courseData.saleprice))" type="primary">立即购买</van-button>
            </div>
            <div v-if="(courseData.isjoin === 1 && courseData.coursetype === 2 && active === 3) || (courseData.isjoin === 1 && courseData.coursetype === 1 && active === 2)"
                 @click="notePop = true" class="box2">
                <img :src="require('@/common/images/mmy/icon_write.png')" alt="">
                <span>记录笔记</span>
            </div>
            <div v-if="(courseData.isjoin === 1 && courseData.coursetype === 2 && active === 2) || (courseData.isjoin === 1 && courseData.coursetype === 1 && active === 1)"
                 @click="discussPop = true" class="box2">
                <img :src="require('@/common/images/mmy/icon_write.png')" alt="">
                <span>参与讨论</span>
            </div>
        </div>
        <div class="pop_div">
            <van-popup v-model="discussPop" position="bottom" :style="{ height: '4.13rem' }">
                <van-cell-group>
                    <van-field maxlength='90' v-model="discussMsg" type="textarea" placeholder="快和大家一起参与课程讨论吧…(不超过90字)"
                               rows="5" autosize/>
                </van-cell-group>
                <van-button type="info" @click="postBtn(1)">发布</van-button>
            </van-popup>
        </div>
        <div class="pop_div">
            <van-popup v-model="notePop" position="bottom">
                <div class="isOpen_box">
                    <van-switch v-model="isSecret" size="0.24rem"/>
                    <span class="span_text">私密笔记</span>
                </div>
                <van-cell-group>
                    <van-field maxlength='90' v-model="noteMsg" type="textarea" placeholder="快来记录你的学习笔记与大家分享吧…(不超过90字)"
                               rows="5" autosize/>
                </van-cell-group>
                <van-button type="info" @click="postBtn(2)">发布</van-button>
            </van-popup>
        </div>
        <!--无有效期-->
        <div class="join_course_pop">
            <van-popup v-model="joinCoursePop" @close="closePop" position="center">
                <div class="join_course_div">
                    <div>
                        <img class="join_course_img" :src="require('@/common/images/mmy/icon_success.png')" alt="">
                        <p>您已成功参加课程， 快去学习吧！</p>
                        <van-button @click="closeJoinSuccessPop('btn')" type="primary">马上学习</van-button>
                    </div>
                    <img @click="closeJoinSuccessPop()" class="close_img"
                         :src="require('@/common/images/mobile/icon-popup-close.png')" alt="">
                </div>
            </van-popup>
        </div>
        <!--有有效期-->
        <div class="confirm_pop">
            <van-popup v-model="confirmPop" @close="cancelPop" position="center">
                <div class="confirm_div">
                    <img class="confirm_img" :src="require('@/common/images/mmy/icon-light.png')" alt="">
                    <div class="confirm_tip">购买后课程有效期为{{courseData.expiredays}}天 确认继续购买吗？</div>
                    <div class="confirm_btn">
                        <span @click="cancelPop" class="cancelBtn">暂不购买</span>
                        <span @click="confirmBuy" class="confirmBtn">确认购买</span>
                    </div>
                </div>
            </van-popup>
        </div>
        <div class="serviceqrurl_pop">
            <van-popup v-model="serviceQrUrlPop" position="center">
                <p class="nama_text">{{courseData.hostinfo.hostname}}</p>
                <img :src="courseData.hostinfo.serviceqrurl" alt="">
                <p class="tip_text">长按识别关注客服微信号</p>
            </van-popup>
        </div>
        <div class="shortcut_box">
            <div @click="jumpClick('MIndex')">
                <img :src="require('@/common/images/other/icom_home.png')" alt="">
                <span>首页</span>
            </div>
            <div @click="posterPop">
                <img :src="require('@/common/images/other/icon_poster.png')" alt="">
                <span>海报</span>
            </div>
            <div @click="handleCommonform" v-if="courseData.iscommonform">
                <img :src="require('@/common/images/other/icon_quesnaire.png')" alt="">
                <span>问卷</span>
            </div>
            <div @click="serviceQrUrlPop = true">
                <img :src="require('@/common/images/other/icon_service.png')" alt="">
                <span>客服</span>
            </div>
        </div>
        <poster ref="poster" :courseData="courseData"></poster>
        <getCoupon ref="getCoupon" />
        <FormDialog ref="formDialog" @fillInOver="fillInOver" />
        <BindMobile ref="bindMobile" />
    </div>
</template>

<script>
  import pdf from 'vue-pdf'
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'
  import {
    getCourseDetail,
    uploadCourseFavorite,
    uploadCourseJoinInfo,
    getAllCourseNotes,
    getCourseMyNotes,
    uploadCourseNotes,
    getCourseTask,
    getCourseDiscuss,
    uploadCourseDiscussInfo,
    getCourseNewDiscuss,
    getCourseTaskInfo
  } from 'api/api'
  import CourseAudioPlayer from 'views/mobile/sort/course/components/CourseAudioPlayer' // 音频播放器
  import {Toast, ImagePreview} from 'vant'
  import {mapGetters, mapActions} from 'vuex'
  import $ from 'jquery'
  import AllNotes from 'views/mobile/sort/course/components/AllNotes'
  import MyNotes from 'views/mobile/sort/course/components/MyNotes'
  import CourseVideoPlayer from 'views/mobile/sort/course/components/courseVideoPlayer'
  import DataList from 'views/mobile/sort/course/components/dataList'
  import Poster from 'views/mobile/sort/course/components/poster'
  import getCoupon from './components/getCoupon'
  import FormDialog from './components/formDialog'
  import BindMobile from 'views/mobile/components/bindMobile/bindMobile'
  import { getAssignKeyLocationSearch, setCookie, examineMobilePhoneType } from 'common/js/tools.js'
  import {getCustomerInfoByApp} from 'api/api'
  
  // import CallApp from 'callapp-lib';
  export default {
    name: 'MCourseView',
    metaInfo: {
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=no'
        }
      ]
    },
    data() {
      return {
        taskid: '',
        pdfLoading: true,
        currentPage: 1,
        pageCount: 0,
        isSecret: false,
        isSuccess: true,
        activeNames: [0],
        active: this.$route.query.active ? this.$route.query.active : 0,
        courseData: {
          isjoin: 0, // 是否参与
          isspeedplay: 0, // 是否倍速播放
          ispreventrecording: 0, // 是否防录屏
          isbuyexpire: 1, // 购买是否有效期-收费有效：0否1是'
          expiredays: 0, // 买有效期天数
          isexpiredays: 0, // 0可以继续查看 1 为1的时候说明已经超过了有效期，不能进行查看
          ishavedoc: 0, // 0无资料 1 为1说明有资料
          iscommonform: 0, // 是否有问卷
          hostinfo: {
            hostlogourl: ''
          }
        }, // 课程详情相关信息
        taskInfoData: {
          kmctype: '',
          totalduration: 0, //  '视频总长度-秒',
          isfinishstudy: 0, //  '是否学习完成',0否 1是
          currentstudytimes: 0, //  '最近学习位置-秒',
          maxstudytimes: 0 //  '最长学习位置-秒',
        },
        currentReportImg: '',
        reportImgPage: 1,
        courseDiscussData: [], // 课程讨论
        isAllNotes: 1, // 全部笔记： 1    我的笔记： 2
        allNotesData: [], // 全部笔记
        myNotesData: [], // 我的笔记
        chapterData: [],
        discussPop: false, // 讨论弹窗
        discussMsg: '', // 讨论内容
        notePop: false, // 笔记弹窗
        noteMsg: '', // 笔记内容
        joinCoursePop: false, // 加入课程成功弹窗
        serviceQrUrlPop: false, // 客服二维码弹窗
        minId: null,
        isLoad: true,
        loading: false,
        finished: false,
        refreshing: false,
        tabsName: [], // tab标签名称
        playbackRate: 1,
        playType: 1, // 1视频 2音频
        confirmPop: false,
        timer: {
          timer: null,
          day: 0,
          hour: 0,
          minute: 0,
          second: 0
        },
        fillInForm: false,
        fillInArr: [],
        showAppTips: false,
        appType: '',
        mobilePhoneType: examineMobilePhoneType(),
        showSubjectHandle: false,
        subjectIsPackup: true
      }
    },
    created() {
        if (!this.domainInfo.isMobile) {
          this.$router.push({
            name: 'CourseDetails',
            query: {'cid': this.$route.query.cid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
          })
        }
        if (getAssignKeyLocationSearch('appflag', ['appByDM', 'appByZJ'])) {
            this.showAppTips = true
            this.appType = getAssignKeyLocationSearch('appflag')
        } else {
            this.showAppTips = false
        }
        if (getAssignKeyLocationSearch('apptoken') && getAssignKeyLocationSearch('appflag', ['appByDM', 'appByZJ'])) {
            this.getCustomerInfoByApp()
        }
    },
    mounted() {
        if (!this.refresh) {
          this.findCourseDetail()
        }
    },
    activated() {
      if (this.refresh) {
        this.active = this.$route.query.active ? this.$route.query.active : 0,
          this.findCourseDetail()
        this.courseDiscussData = []
        this.allNotesData = []
        this.myNotesData = []
        this.chapterData = []
        this.taskInfoData = {
          kmctype: ''
        }
        // if (this.$route.query.active) {
        //     this.findCourseTask()
        // }
        this.setRefresh(false)
      } else {
        if (this.courseData.islimitcount && this.courseData.endtime) {
          let endtime = new Date(this.courseData.endtime).getTime()
          if (this.timer.timer) clearInterval(this.timer.timer)
          this.timer.timer = setInterval(() => {
            this._initTimer(endtime)
          }, 1000)
        }
      }
    },
    methods: {
      getCustomerInfoByApp() {
          this.setLoading(true)
          getCustomerInfoByApp({
              data: {},
              success: data => {
                  this.setLoading(false)
                  let user = {
                      innerid: data.data.innerid ? data.data.innerid : '',
                      isperfect: data.data.isperfect ? data.data.isperfect : '',
                      loginToken: data.data.logintoken ? data.data.logintoken : '',
                      loginname: data.data.loginname ? data.data.loginname : '',
                      logourl: data.data.logourl ? data.data.logourl : '',
                      mobile: data.data.mobile ? data.data.mobile : '',
                      name: data.data.name ? data.data.name : '',
                      nickname: data.data.nickname ? data.data.nickname : '',
                      isLogin: true,
                      zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                  }
                  this.setUser(user)
                  sessionStorage.setItem('user', JSON.stringify(user))
                  setCookie('token', user.loginToken, 7)
              },
              error: data => {
                  this.setLoading(false)
                  this.$toast.fail(data.msg)
              }
          })
      },
      handleGoQbDetails(item) {
          this.$router.push({
            name: 'PaperDetails',
            query: {
              qid: item.qbid,
              courseid: this.$route.query.cid
            }
          })
      },
      handleCommonform() {
        this.setRefresh(true)
        this.$router.push({name: 'Questionnaire', query: {commonid: this.courseData.commonid, kmctype: 7, kmcinnerid: this.courseData.courseid}})
      },
      openGetCoupon() {
        this.$refs.getCoupon.open(this.courseData)
      },
      setFullScreen() {
        this.$refs.courseVideoPlayer.setFullScreen()
      },
      toChangePlay() {
        if ( this.playType === 1) {
          this.playType = 2
        } else {
          this.playType = 1
        }
        this.$refs.courseVideoPlayer.setPlayType(this.playType)
      },
      posterPop() {
        this.$refs.poster.openPop()
      },
      handlePlaySpeed() {
        if (this.playbackRate + 0.5 > 2) {
          this.playbackRate = 0.5
        } else {
          this.playbackRate = this.playbackRate + 0.5
        }
        this.$refs.courseVideoPlayer.setPlaySpeed(this.playbackRate)
      },
      toReportPrview() {
        this.setRefresh(true)
        this.$router.push({name: 'MCourseReportPrview', query: {'taskid': this.taskid}})
      },
      // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
      changePdfPage(val) {
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },
      // getPdfPageCount(e) {
      //     this.pageCount = e
      // },
      // // pdf加载时
      // loadPdfHandler (e) {
      //     this.currentPage = 1 // 加载的时候先加载第一页
      // },
      _isWixin() {
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
          return true
        } else {
          return false
        }
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        // this.loading = true
        this.findCourseNewDiscuss(this.courseDiscussData[0].comid)
      },
      onLoad() {
        if (this.isLoad) {
          this.findCourseDiscuss(this.minId)
        } else {
          this.finished = true
          this.loading = false
        }
      },
      tabChange(e, event) {
        if (event === '笔记') {
          if (this.allNotesData.length === 0) {
            this.findAllCourseNotes(1)
          }
        }
        if (event === '目录') {
          if (this.chapterData.length === 0) {
            this.findCourseTask()
          }
        }
        if (event === '讨论') {
          if (this.courseDiscussData.length === 0) {
            this.findCourseDiscuss(-1)
          }
        }
        if (event === '资料') {
          if (this.courseData.ishavedoc) {
            this.$nextTick(() => {
              this.$refs.dataList[0].init()
            })
          }
        }
      },
      // 全部笔记  我的笔记  切换
      isAllNotesClick(val) {
        this.isAllNotes = val
        if (val === 2 && this.myNotesData.length === 0) {
          this.findMyCourseNotes(1)
        }
      },
      // 图片预览
      imgPreview(value) {
        let imgList = []
        for (let index = 0; index < value.length; index++) {
          imgList.push(value[index].reportimageurl)
        }
        ImagePreview({
          images: imgList,
          startPosition: this.reportImgPage - 1,
          maxZoom: 10,
          minZoom: 1 / 5
        })
      },
      // 获取课程详情（含机构信息）
      findCourseDetail() {
        var params = {
          courseid: this.$route.query.cid,
          channelid: this.$route.query.chid ? this.$route.query.chid : ''
        }
        getCourseDetail({
          data: Object.assign({}, params),
          success: data => {
            data.data.kmctype = 7
            data.data.kmcid = this.$route.query.cid
            this.courseData = data.data
            if (this.courseData.islimitcount && this.courseData.endtime) {
              let endtime = new Date(this.courseData.endtime).getTime()
              if (this.timer.timer) clearInterval(this.timer.timer)
              this.timer.timer = setInterval(() => {
                this._initTimer(endtime)
              }, 1000)
            }
            this.courseData.evaluatecount = parseInt(this.courseData.evaluatecount)
            document.title = this.courseData.subject
            this.isSuccess = false
            if (this._isWixin()) {
              let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?cid=' + this.$route.query.cid + '&chid=' + (this.$route.query.chid ? this.$route.query.chid : '')
              getWXSDKSetting({
                title: this.courseData.subject,
                desc: this.courseData.sharecontent,
                link: link,
                imgUrl: this.courseData.coverurl
              })
            }
            if (this.courseData.coursetype === 1 && this.courseData.isjoin === 1) {
              this.taskid = this.courseData.taskid
              this.getTaskInfo(this.courseData.taskid)
            }
            if (this.courseData.coursetype === 2) {
              // this.tabsName = ['详情', '目录', '讨论', '笔记']
              this.tabsName = ['详情', '目录', '笔记']
              if (this.courseData.relqblist && this.courseData.relqblist.length) {
                this.tabsName = ['详情', '目录', '题库', '笔记']
              }
              this.findCourseTask()
            } else {
              // this.tabsName = ['详情', '讨论', '笔记']
              this.tabsName = ['详情', '笔记']
              if (this.courseData.relqblist && this.courseData.relqblist.length) {
                this.tabsName = ['详情', '题库', '笔记']
              }
            }
            if (this.courseData.ishavedoc) {
              this.tabsName.push('资料')
            }
            this.$nextTick(() => {
                let subjectHeight = document.getElementById('subjectDiv').offsetHeight
                let subjectBoxHeight = document.getElementById('courseSubjectBox').offsetHeight
                if (subjectHeight - subjectBoxHeight > 10) {
                  this.showSubjectHandle = true
                } else {
                  this.showSubjectHandle = false
                }
            })
          },
          error: () => {
            this.isSuccess = true
          }
        })
      },
      handleChangeSubjectIsPackup() {
        this.subjectIsPackup = !this.subjectIsPackup
        this.$nextTick(() => {
          if (this.subjectIsPackup) {
            document.getElementById('courseSubjectBox').style.height = 'auto'
            document.getElementById('courseSubjectBox').style.maxHeight = '0.84rem'
          } else {
            document.getElementById('courseSubjectBox').style.height = document.getElementById('subjectDiv').offsetHeight + 'px'
            document.getElementById('courseSubjectBox').style.maxHeight = document.getElementById('subjectDiv').offsetHeight + 'px'
          }
        })
      },
      _initTimer(endtime) {
        let current = new Date().getTime()
        let time = (endtime - current ) / 1000
        this.timer.day = parseInt(time / 3600 / 24)
        this.timer.hour = parseInt(time / 3600) % 24 < 10 ? '0' + parseInt(time / 3600) % 24 : parseInt(time / 3600) % 24
        this.timer.minute = parseInt(time /60) % 60 < 10 ? '0' + parseInt(time /60) % 60 : parseInt(time /60) % 60
        this.timer.second = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
      },
      // 收藏课程
      enshrineClick(val) {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid,
          optype: val === 1 ? 2 : 1,
          kmctype: 7,
        }
        uploadCourseFavorite({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            if (data.code === '000') {
              if (val === 1) {
                this.courseData.isfavorite = 0
                Toast('已取消收藏')
              } else {
                this.courseData.isfavorite = 1
                Toast('收藏成功')
              }
            }
          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 去会员详情
      handleGoMemberDetails() {
          this.$router.push({name: 'MMemberDetails', query: {chid: this.$route.query.chid ? this.$route.query.chid : ''}})
      },
      // 购买课程
      buyCourseBtn() {
        if (this.user.isLogin) {
          if (this.courseData.isbuyexpire) {
            this.confirmPop = true
          } else {
            this.confirmBuy()
          }
        } else {
          this.$router.push({name: 'MLogin'})
        }
      },
      cancelPop() {
        this.confirmPop = false
      },
      confirmBuy() {
        this.$router.push({name: 'MConfirmOrder', query: {'cid': this.courseData.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
      },
      fillInOver(arr) {
        this.fillInForm = true
        this.fillInArr = arr
        this.joinCourseBtn()
      },
      // 提交参与课程（免费课程有效）
      joinCourseBtn() {
        if (this.user.isLogin) {
          if (!this.user.isperfect) {
              this.$refs.bindMobile.showCheckBindMobile()
              return
          }
          if (this.courseData.isform && !this.fillInForm) {
              this.$refs.formDialog.open(this.courseData.formlist)
          } else {
              this.setLoading(true)
              var params = {
                courseid: this.$route.query.cid,
                userformlist: JSON.stringify(this.fillInArr),
                channelid: this.$route.query.chid ? this.$route.query.chid : ''
              }
              uploadCourseJoinInfo({
                data: Object.assign({}, params),
                success: data => {
                  this.setLoading(false)
                  if (data) {
                    this.joinCoursePop = true
                  }
                },
                error: () => {
                  this.setLoading(false)
                }
              })
          }
        } else {
          this.$router.push({name: 'MLogin'})
        }
      },
      // 关闭参与成功弹窗
      closeJoinSuccessPop(val) {
        this.joinCoursePop = false
        this.courseData.isjoin = 1
        if (this.courseData.coursetype === 1) {
          this.taskid = this.courseData.taskid
          this.getTaskInfo(this.courseData.taskid)
        }
        if (val === 'btn') {
          this.active = 1
        }
      },
      // 获取课程目录（系列课，通用）
      findCourseTask() {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid
        }
        getCourseTask({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            this.isSuccess = false
            this.chapterData = data.data.content
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      // 获取用户讨论信息（返回最小id做分页）
      findCourseDiscuss(val) {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid,
          minmsgid: val,
          pageSize: 10
        }
        getCourseDiscuss({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            this.loading = false
            this.finished = false
            var disMinId = this.minId
            this.courseDiscussData = this.courseDiscussData.concat(data.data.discussinfo)
            this.minId = this.courseDiscussData[this.courseDiscussData.length - 1].comid
            if (disMinId === this.minId) {
              this.isLoad = false
              this.finished = true
            }

          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 获取用户讨论信息（返回最小id做分页）
      findCourseNewDiscuss(val) {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid,
          maxmsgid: val,
          pageSize: 10
        }
        getCourseNewDiscuss({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            var arry = data.data.discussinfo
            var arry2 = this.courseDiscussData
            arry = arry.concat(arry2)
            this.courseDiscussData = arry
            this.refreshing = false
          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 获取全部笔记（公开的）
      findAllCourseNotes(val) {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid,
          page: val,
          pagesize: 10
        }
        getAllCourseNotes({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            this.allNotesData = data.data.notesinfo
          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 获取我的笔记
      findMyCourseNotes(val) {
        this.setLoading(true)
        var params = {
          courseid: this.$route.query.cid,
          page: val,
          pagesize: 10
        }
        getCourseMyNotes({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            this.myNotesData = data.data.notesinfo
          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 发布讨论或者笔记
      postBtn(val) {
        if (val === 1) {
          this.publishDiscussInfo()
        } else {
          this.publishNote()
        }
      },
      // 提交用户讨论
      publishDiscussInfo() {
        if (this.discussMsg === '') {
          Toast('讨论内容不能为空')
        } else {
          this.setLoading(true)
          var params = {
            courseid: this.$route.query.cid,
            content: this.discussMsg
          }
          uploadCourseDiscussInfo({
            data: Object.assign({}, params),
            success: () => {
              this.setLoading(false)
              this.discussPop = false
              this.discussMsg = ''
              if (this.courseDiscussData.length === 0) {
                this.findCourseDiscuss(-1)
              } else {
                this.findCourseNewDiscuss(this.courseDiscussData[0].comid)
              }
              Toast('课程讨论发布成功')
              this.goTop(300, 212)
            },
            error: () => {
              this.setLoading(false)
            }
          })
        }
      },
      // 提交用户笔记
      publishNote() {
        if (this.noteMsg === '') {
          Toast('笔记内容不能为空')
        } else {
          this.setLoading(true)
          var params = {
            courseid: this.$route.query.cid,
            content: this.noteMsg,
            ispublic: 1
          }
          if (this.isSecret) {
            params.ispublic = 0
          } else {
            params.ispublic = 1
          }
          uploadCourseNotes({
            data: Object.assign({}, params),
            success: () => {
              this.setLoading(false)
              this.notePop = false
              this.noteMsg = ''
              this.goTop(300, 212) // 回到tab顶部
              // 如果发布的是私密笔记  就不调取全部笔记最新信息
              if (!this.isSecret) {
                this.$refs.allNotesRef.findMyPostAllNotes()
              }
              this.$refs.myNotesRef.findMyPostNotes()
              Toast('课程笔记发布成功')
            },
            error: () => {
              this.setLoading(false)
            }
          })
        }
      },
      // 系列课章节任务点击
      freeModeCourseTaskClick(taskItem, isjoin) {
        if (taskItem.istry === '1') {
          if (this.taskid !== taskItem.innerid) {
              this.taskid = taskItem.innerid
              if (this.taskInfoData.kmctype === 4 && this.playType === 2) {
                  this.$refs.courseVideoPlayer.$refs.audio.pause()
              }
              this.getTaskInfo(taskItem.innerid)
          }
        } else {
          if (isjoin === 1) {
            if (this.taskid !== taskItem.innerid) {
                this.taskid = taskItem.innerid
                if (this.taskInfoData.kmctype === 4 && this.playType === 2) {
                    this.$refs.courseVideoPlayer.$refs.audio.pause()
                }
                this.getTaskInfo(taskItem.innerid)
            }
          } else {
            Toast('请先购买课程！')
          }
        }
      },
      // 解锁模式章节任务点击
      UnlockPatternClick(taskItem, isjoin) {
        if (taskItem.istry === '1') {
          if (this.taskid !== taskItem.innerid) {
              this.taskid = taskItem.innerid
              if (this.taskInfoData.kmctype === 4 && this.playType === 2) {
                  this.$refs.courseVideoPlayer.$refs.audio.pause()
              }
              this.getTaskInfo(taskItem.innerid)
          }
        } else {
          if (isjoin === 1) {
            if (taskItem.isunlock === 1) {
              if (this.taskid !== taskItem.innerid) {
                  this.taskid = taskItem.innerid
                  if (this.taskInfoData.kmctype === 4 && this.playType === 2) {
                      this.$refs.courseVideoPlayer.$refs.audio.pause()
                  }
                  this.getTaskInfo(taskItem.innerid)
              }
              
            } else {
              Toast('暂未解锁，请于指定日期观看')
            }

          } else {
            Toast('请先购买课程！')
          }
        }
      },
      getTaskInfo(val) {
        this.setLoading(true)
        var params = {
          taskid: val
        }
        getCourseTaskInfo({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            this.playType = 1
            data.data.taskid = val
            this.taskInfoData = data.data
            if (this.taskInfoData.kmctype === 4) {
              this.$nextTick(() => {
                this.playbackRate = 1
                this.$refs.courseVideoPlayer.getVideo(this.taskInfoData)
              })
            } else if (this.taskInfoData.kmctype === 6) {
                this.$nextTick(() => {
                    if (!this.$refs.courseAudioPlayer.play) {
                        this.$refs.courseAudioPlayer.audioState()
                    }
                })
            }
            this.goTop(200, 0)
            if (data.data.kmctype === 2 && this.taskInfoData.reportimageinfo.length > 0) {
              // 电子书
              this.currentReportImg = this.taskInfoData.reportimageinfo[0].reportimageurl
            }
            if (data.data.kmctype === 2 && this.taskInfoData.reportimageinfo.length === 0) {
              this.currentPage = 1
              this.pdfLoading = true
              this.taskInfoData.fullfileurl = pdf.createLoadingTask(this.taskInfoData.fullfileurl)
              this.taskInfoData.fullfileurl.then(pdf => {
                this.pageCount = pdf.numPages
                this.pdfLoading = false
              })
            }
          },
          error: () => {
            this.setLoading(false)
          }
        })
      },
      // 报告类型图片点击
      reportImgClick(val) {
        this.currentReportImg = val.reportimageurl
        this.reportImgPage = val.reportimageindex
      },
      // 关闭参与课程成功弹窗
      closePop() {
        this.joinCoursePop = false
        this.courseData.isjoin = 1
        if (this.courseData.coursetype === 1) {
          this.taskid = this.courseData.taskid
          this.getTaskInfo(this.courseData.taskid)
        }
      },
      // 跳转至机构页面
      toOrganPage() {
        this.setRefresh(true)
        this.$router.push({name: 'MAgencyView', query: {'hostid': this.courseData.hostinfo.hostid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
      },
      // 跳转至课程评价
      toEvaPage() {
        this.setRefresh(true)
        this.$router.push({name: 'MCourseEvaluation', query: {'cid': this.courseData.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
      },
      jumpClick(val) {
        this.$router.push({name: val})
      },
      // 章节任务tag
      tagText(val) {
        if (val === '报告') {
          return '电子书'
        } else {
          return val
        }
      },
      // 回到顶部
      goTop(s, t) {
        // $('#coursedetailswarp').animate({scrollTop:'0'},500)
        $("html,body").animate({
          scrollTop: t
        }, s)
      },
      openApp() {
          if (this.appType === 'appByDM') {
              window.location.href = 'https://www.capwhale.com/ulink/iosdmapp/course/courseDetails/courseDetails?courseid=' + this.courseData.courseid
          } else if (this.appType === 'appByZJ') {
              window.location.href = 'https://www.capwhale.com/ulink/ioscapwhale/course/courseDetails/courseDetails?courseid=' + this.courseData.courseid
          }
          // if (this.mobilePhoneType === 'iOS') {
              
          // } else {
          //     window.location.href = 'dmapp://course/courseDetails/courseDetails?courseid=' + this.courseData.courseid
          // }
      },
      handlewxOpenApperror(e) {
          let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?cid=' + this.courseData.courseid + '&appflag=' + this.appType
          if (e.detail.errMsg === 'launch:fail') { // 未安装APP
              if (this.appType === 'appByDM') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                  }
              } else if (this.appType === 'appByZJ') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                  }
              }
          } else if (e.detail.errMsg === 'launch:fail_check fail') { // appid未绑定未关联到微信
              if (this.appType === 'appByDM') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                  }
              } else if (this.appType === 'appByZJ') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                  }
              }
          }
      },
      handleClickOpenApp() {
          let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?cid=' + this.courseData.courseid + '&appflag=' + this.appType
          setTimeout(() => {
              if (this.appType === 'appByDM') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                  }
              } else if (this.appType === 'appByZJ') {
                  if (this.mobilePhoneType === 'iOS') {
                      window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                  } else {
                      window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                  }
              }
          }, 2000)
      },
      ...mapActions(['setLoading', 'setLoginPop', 'setUser',  'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['loginPop', 'user', 'refresh', 'domainInfo'])
    },

    beforeRouteLeave(to, from , next) {
      clearInterval(this.timer.timer)
      next()
    },
    components: {
      CourseAudioPlayer, AllNotes, MyNotes, pdf, CourseVideoPlayer, DataList, Poster, getCoupon,
      FormDialog, BindMobile
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */
    {
        opacity: 0
    }

    .padding0 {
        padding-bottom: 0 !important;
    }

    .MCourseView {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        font-family: PingFangSC-Medium, PingFang SC;
        width: 100vw;
        max-width: 100vw;
        min-height: 100vh;
        padding-bottom: 1.2rem;
        box-sizing: border-box;
        position: relative;
        color: #333;
        .dmAppTips {
            // position: fixed;
            // top: 0;
            // left: 0;
            width: 100%;
            height: 0.9rem;
            background: #333;
            z-index: 1000;
            display: flex;
            position: relative;
            .leftTips {
                flex: 1;
                display: flex;
                align-items: center;
                padding: 0 0.2rem;
                .closeIcon {
                    width: 0.25rem;
                    height: 0.25rem;
                    margin-right: 0.3rem;
                }
                .logo {
                    width: 0.6rem;
                    height: 0.6rem;
                }
                .text {
                    flex: 1;
                    color: #fff;
                    font-size: 0.28rem;
                    text-align: center;
                }
            }
            .wechatOpenApp {
              position: absolute;
              width: 25%;
              height: 100%;
              right: 0;
              top: 0;
              overflow: hidden;
              z-index: 10000;
              background: transparent;
            }
            .rightOpenApp {
                width: 25%;
                text-align: center;
                height: 100%;
                background: #F63515;
                color: #fff;
                line-height: 0.9rem;
                font-size: 0.28rem;
                // background: ;
            }
        }
        .course_top_box {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 4.22rem;
            & > img {
                width: 100%;
                height: 4.22rem;
            }
            .curriculum_report_pdf_box {
                width: 100%;
                height: 4.22rem;
                background-color: rgb(255, 255, 255);
                position: relative;
                & > span {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }
                canvas {
                    width: auto !important;
                    height: 4.22rem !important;
                }
                .img_icon {
                    position: absolute;
                    top: 1.61rem;
                    width: 0.46rem;
                    height: 0.46rem;
                }
                .left_img_icon {
                    left: 0.2rem;
                }
                .right_img_icon {
                    right: 0.2rem;
                }
                .bottom_div {
                    box-sizing: border-box;
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    font-size: 0.26rem;
                    background: rgba(0, 0, 0, 0.8);
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 0.54rem;
                    padding: 0 0.32rem;
                    img {
                        width: 0.26rem;
                        height: 0.26rem;
                    }
                }
            }
            .curriculum_report {
                position: absolute;
                top: 0;
                width: 100%;
                height: 4.22rem;
                color: #FFF;
                background-color: rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
                & > img {
                    max-width: 100%;
                    max-height: 4.22rem;
                }
                .top {
                    box-sizing: border-box;
                    width: 100%;
                    padding: 0 0.32rem;
                    display: flex;
                    align-items: center;
                    height: 0.96rem;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    background: rgba(0, 0, 0, 0.5);
                    position: absolute;
                    bottom: 0.54rem;
                    .active {
                        border: 0.02rem solid rgba(64, 158, 255, 1);
                    }
                    & > div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 0.67rem;
                        min-width: 0.67rem;
                        height: 0.67rem;
                        background-color: #D8D8D8;
                        margin-right: 0.12rem;
                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }
                }
                .top::-webkit-scrollbar {
                    display: none
                }
                .bottom {
                    box-sizing: border-box;
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    font-size: 0.26rem;
                    background: rgba(0, 0, 0, 0.8);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 0.54rem;
                    padding: 0 0.32rem;
                    img {
                        width: 0.26rem;
                        height: 0.26rem;
                    }
                }
            }
            .curriculum_report_full_screen {
                position: fixed;
                top: 0;
                z-index: 1000;
                width: 100%;
                height: 100vh;
                color: #FFF;
                background-color: rgb(0, 0, 0);
                .curriculum_report_img_box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 85vh;
                    & > img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
                .top {
                    box-sizing: border-box;
                    width: 100%;
                    padding: 0 0.32rem;
                    display: flex;
                    align-items: center;
                    height: 9vh;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    background: #78797A;
                    .active {
                        border: 0.02rem solid rgba(64, 158, 255, 1);
                    }
                    & > div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 0.67rem;
                        min-width: 0.67rem;
                        height: 0.67rem;
                        background-color: #D8D8D8;
                        margin-right: 0.12rem;
                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }
                }
                .top::-webkit-scrollbar {
                    display: none
                }
                .bottom {
                    box-sizing: border-box;
                    width: 100%;
                    font-size: 0.26rem;
                    background: #303031;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 6vh;
                    padding: 0 0.32rem;
                    img {
                        width: 0.26rem;
                        height: 0.26rem;
                    }
                }
            }
            .curriculum_video {
                position: absolute;
                top: 0;
            }
            .curriculum_audio {
                position: absolute;
                bottom: 0.2rem;
                background: rgba(255, 255, 255, 0.8);
                box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
                border-radius: 0.1rem;
            }
        }
        .video-btns{
            height: 0.72rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: #fff;
            margin-bottom: 0.2rem;
            padding: 0 0.32rem;
            .video-btn{
                border: 0.01rem solid  #E5E5E5;
                font-size: 0.24rem;
                color: #666666;
                height: 0.48rem;
                line-height: 0.48rem;
                border-radius: 0.24rem;
                padding: 0 0.24rem;
                margin-left: 0.2rem;
            }
        }
        .limit-box{
            padding: 0.18rem 0.32rem;
            display: flex;
            justify-content: space-between;
            height: 1.2rem;
            background: linear-gradient(24deg, #FF4952 0%, #FF8047 100%);
            color: #fff;
            box-sizing: border-box;
            .left{
                .tagname{
                    display: inline-block;
                    background: #ED4642;
                    border-radius: 0.2rem;
                    padding: 0 0.1rem;
                    height: 0.32rem;
                    width: auto;
                    line-height: 0.32rem;
                }
                .price-box{
                    height: 0.6rem;
                    margin-top: 0.1rem;
                    .saleprice{
                        font-size: 0.42rem;
                        font-weight: 600;
                    }
                    .uprice{
                        font-size: 0.28rem;
                        margin-left: 0.2rem;
                        text-decoration:line-through
                    }
                }
            }
            .right{
              .tip{
                  height: 0.32rem;
                  font-size: 0.24rem;
                  text-align: right;
              }
                .timer-box{
                    font-size: 0.28rem;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    height: 0.6rem;
                    .time-box{
                        width: 0.36rem;
                        height: 0.36rem;
                        background: #FFFFFF;
                        border-radius: 0.04rem;
                        color: #EC5E69;
                        font-size: 0.2rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .sepa-r{
                        margin-right: 0.08rem;
                    }
                    .sepa-l{
                        margin-left: 0.08rem;
                    }
                }
            }
        }
        .course_second_info {
          background: #fff;
          padding: 0.28rem 0.32rem;
          box-sizing: border-box;
          &.marginBottom20 {
            margin-bottom: 0.2rem;
          }
            .price_collect {
              display: flex;
              align-items: center;
              margin-bottom: 0.16rem;
              .price {
                flex: 1;
                display: flex;
                align-items: center;
                .saleprice {
                  font-size: 0.46rem;
                  color: #F24945;
                  display: block;
                  line-height: 0.54rem;
                  // font-weight: bold;
                  .unit {
                    font-size: 0.32rem;
                  }
                }
                .uprice {
                  font-size: 0.24rem;
                  color: #666666;
                  text-decoration: line-through;
                  margin-left: 0.1rem;
                }
                .div_price {
                    display: flex;
                    align-items: center;
                    .plusPriceIcon1 {
                      width: 1.13rem;
                      height: 0.32rem;
                      margin: 0 0.05rem 0 0.18rem;
                    }
                    .plusPriceIcon2 {
                      width: 0.8rem;
                      height: 0.32rem;
                      margin: 0 0.05rem 0 0.18rem;
                    }
                    .plusPrice {
                      font-size: 0.24rem;
                      color: #666666;
                    }
                }
              }
              .collect {
                display: flex;
                align-items: center;
                .collect_icon {
                  width: 0.3rem;
                  min-width: 0.3rem;
                  height: 0.3rem;
                  min-height: 0.3rem;
                  margin-right: 0.1rem;
                }
                .collect_text {
                  font-size: 0.26rem;
                  color: #999999;
                }
              }
            }
            .course_subject_box {
              position: relative;
              height: auto;
              max-height: 0.84rem;
              overflow: hidden;
              transition: all 0.3s;
              .subject {
                font-size: 0.36rem;
                color: #333333;
                font-weight: bold;
                display: inline-block;
                line-height: 0.42rem;
                &.inline {
                  display: inline;
                }
              }
              .handleIconBox {
                display: inline-block;
                width: 0.38rem;
                height: 0.38rem;
                background: #fff;
                text-align: center;
                line-height: 0.38rem;
                position: relative;
                bottom: -0.08rem;
                .subjectHandle {
                    width: 0.24rem;
                    height: 0.12rem;
                    transform: rotate(180deg);
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                }
                &.packup {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .subjectHandle {
                      transform: rotate(0);
                  }
                }
              }
            }
            .memberTips {
                width: 100%;
                background: #FFF8E6;
                border-radius: 0.1rem;
                padding: 0 0.2rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 0.52rem;
                margin-top: 0.28rem;
                box-sizing: border-box;
                .iconTips {
                    display: flex;
                    align-items: center;
                    .memberIcon {
                        width: 0.3rem;
                        height: 0.3rem;
                        margin-right: 0.1rem;
                    }
                    .tips {
                        font-size: 0.26rem;
                        color: #BB7221;
                        font-weight: bold;
                    }
                }
                .arrowIcon {
                    width: 0.12rem;
                    height: 0.24rem;
                }
            }
        }
        .coupon_box {
          padding: 0 0.32rem 0.28rem;
          background: #fff;
          margin-bottom: 0.2rem;
          border-top: 0.01rem solid #E5E5E5;
            .coupon {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 0.28rem;
              // border-top: 0.01rem solid #E5E5E5;
                .left {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .name {
                    font-size: 0.28rem;
                    color: #999999;
                    margin-right: 0.3rem;
                  }
                  .get_coupon {
                    font-size: 0.24rem;
                    color: #FE666D;
                    background: #FEE4E5;
                    padding: 4px 20px;
                    box-sizing: border-box;
                    margin-right: 20px;
                  }
                  .item {
                    font-size: 0.24rem;
                    color: #FE666D;
                    border: 0.01rem solid #FE666D;
                    margin-right: 0.2rem;
                    padding: 0.04rem 0.2rem;
                    border-radius: 0.04rem;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 1.5rem;
                    &.theSecond {
                      margin-right: 0;
                    }
                  }
                }
                .right {
                  img {
                    width: 0.15rem;
                    height: 0.25rem;
                  }
                }
            }
        }
        .organ_box {
            padding: 0.28rem 0.32rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            box-sizing: border-box;
            margin-bottom: 0.2rem;
            height: 1.04rem;
            & > img {
                width: 0.15rem;
                height: 0.26rem;
            }
            & > div {
                display: flex;
                justify-content: space-between;
                & > img {
                    width: 0.48rem;
                    height: 0.48rem;
                    margin-right: 0.2rem;
                }
                & > div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    p:nth-of-type(1) {
                        font-size: 0.32rem;
                        font-weight: bold;
                        line-height: 0.45rem;
                        // margin-bottom: 0.12rem;
                    }
                    p:nth-of-type(2) {
                        font-size: 0.24rem;
                        line-height: 0.33rem;
                        color: #999;
                    }
                }
            }
        }
        .course_tabs_box {
            flex: 1;
            background-color: #FFF;
            .van-tabs__wrap {
                border-bottom: 0.01rem solid #E5E5E5;
            }
            .van-tabs__nav--line {
                padding-bottom: 0.16rem;
            }
            .margin_bottom20 {
                margin-bottom: 0.2rem;
            }
            .tabs_item_box {
                background-color: #F5F7FA;
                & > div {
                    background-color: #fff;
                }
                .no_data_box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 1.3rem 0;
                    & > img {
                        width: 1.68rem;
                        height: 1.62rem;
                    }
                    & > p {
                        margin-top: 0.3rem;
                        color: #999;
                        font-size: 0.26rem;
                        line-height: 0.4rem;
                    }
                }
            }
            .details_warp {
                .course_info_box {
                    .course_info {
                        padding: 0.32rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .course_info_left_box {
                          & > p:nth-of-type(1) {
                              width: 5.9rem;
                              font-size: 0.32rem;
                              line-height: 0.45rem;
                              font-weight: bold;
                              margin-bottom: 0.08rem;
                          }
                          & > p:nth-of-type(2) {
                              display: flex;
                              align-items: center;
                              & > span {
                                  line-height: 0.33rem;
                                  font-size: 0.24rem;
                                  color: #666;
                              }
                              & > span:nth-of-type(2) {
                                  margin-left: 0.32rem;
                              }
                          }
                      }
                      .course_info_right_box {
                          height: 0.48rem;
                          position: relative;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          align-items: center;
                          padding-left: 0.31rem;
                          margin-left: 0.2rem;
                          border-left: 0.01rem solid #E5E5E5;
                          & > img {
                              width: 0.44rem;
                              min-width: 0.44rem;
                              height: 0.44rem;
                              min-height: 0.44rem;
                              margin-bottom: 0.06rem;
                          }
                          & > span {
                              font-size: 0.22rem;
                              white-space: nowrap;
                          }
                          .yellow_text {
                              color: #FFA904;
                          }
                      }
                    }
                }
                .evaluate_box {
                    padding: 0.29rem 0.32rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    p:nth-of-type(1) {
                        font-size: 0.3rem;
                        line-height: 0.42rem;
                    }
                    p:nth-of-type(2) {
                        font-size: 0.26rem;
                        line-height: 0.37rem;
                        color: #409EFF;
                        display: flex;
                        align-items: center;
                        & > img {
                            width: 0.15rem;
                            height: 0.26rem;
                            margin-left: 0.2rem;
                        }
                    }
                }
                .course_details_div {
                    padding: 0 0.1rem;
                    * {
                        max-width: 100%;
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                    }
                    img {
                        max-width: 100%;
                        position: relative;
                        // line-height: 0;
                        vertical-align: middle;
                    }
                }
            }
            .catalogue_warp {
                padding-top: 0.2rem;
                .catalogue_content {
                    .van-cell:not(:last-child)::after {
                        width: 0;
                    }
                    .van-collapse-item__title {
                        display: flex;
                        align-items: center;
                    }
                    .van-cell__title {
                        display: flex;
                        align-items: center;
                        & > div {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            span:nth-of-type(1) {
                                font-size: 0.28rem;
                                color: #303133;
                                font-weight: bold;
                                width: 5.6rem;
                                line-height: 0.4rem;
                            }
                            span:nth-of-type(2) {
                                font-size: 0.24rem;
                                color: #909399;
                            }
                        }
                    }
                    .van-collapse-item__content {
                        padding: 0;
                        padding-bottom: 0.1rem;
                        .chapter_item {
                            padding: 0 0.32rem;
                            color: #303133;
                            height: 0.76rem;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .left {
                                display: flex;
                                align-items: center;
                                .task_tag {
                                    width: 0.86rem;
                                    height: 0.36rem;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border: 0.02rem solid rgba(48, 49, 51, 1);
                                    border-radius: 0.04rem;
                                    margin-right: 0.2rem;
                                }
                                span {
                                    width: 4.26rem;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    word-break: break-all;
                                }
                            }
                            &.is_active {
                              .left {
                                .task_tag {
                                  border-color: #409EFF;
                                  color: #409EFF;
                                }
                                span {
                                  color: #409EFF;
                                }
                              }
                            }
                            .right {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 1rem;
                                .try_tag {
                                    width: 1rem;
                                    height: 0.46rem;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border-radius: 0.23rem;
                                    color: #409EFF;
                                    border: 0.02rem solid rgba(64, 158, 255, 1);
                                }
                                img {
                                    width: 0.34rem;
                                    height: 0.34rem;
                                }
                            }
                        }
                        .chapter_item_disabled {
                            color: #909399;
                            .left {
                                .task_tag {
                                    border: 0.02rem solid #909399;
                                }
                            }
                        }
                        .no_content {
                            padding: 0.32rem 0;
                        }
                    }
                    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
                        border-width: 0;
                    }
                }
                // 自由模式
                .free_schema {
                    .van-cell__title {
                        & > div {
                            span:nth-of-type(1) {
                                width: 100%;
                            }
                        }
                    }
                }
            }
            .comment_warp {
                padding-top: 0.2rem;
                .comment_list_box {
                    padding: 0 0.32rem;
                    .van-pull-refresh {
                        min-height: 40vh;
                    }
                    .comment_item_box {
                        border-bottom: 1px solid #E5E5E5;
                        padding: 0.32rem 0;
                        & > div {
                            display: flex;
                            align-items: center;
                            & > img {
                                width: 0.8rem;
                                height: 0.8rem;
                                border-radius: 50%;
                                margin-right: 0.2rem;
                            }
                            & > div {
                                & > p {
                                    line-height: 0.33rem;
                                    font-size: 0.24rem;
                                }
                                .name_text {
                                    margin-bottom: 0.04rem;
                                }
                                .date_text {
                                    color: #999;
                                }
                            }
                        }
                        & > p {
                            text-align: justify;
                            margin-top: 0.15rem;
                            line-height: 0.4rem;
                            font-size: 0.26rem;
                            padding-left: 1rem;
                        }
                    }
                    .comment_item_box:nth-last-of-type(1) {
                        border: none;
                    }
                }
                .no_data_box {
                    padding: 2rem 0;
                }
            }
            .notes_warp {
                .notes_select_tabs {
                    display: flex;
                    background: rgba(245, 247, 250, 1);
                    height: 0.96rem;
                    & > div {
                        width: 50%;
                        line-height: 0.96rem;
                        text-align: center;
                        font-size: 0.28rem;
                        position: relative;
                    }
                    .notes_active {
                        color: rgba(64, 158, 255, 1);
                    }
                    .notes_active::before {
                        content: '';
                        border-style: solid;
                        border-top-width: 0.15rem;
                        border-bottom-width: 0.15rem;
                        border-left-width: 0.125rem;
                        border-right-width: 0.125rem;
                        border-color: transparent transparent #FFF transparent;
                        position: absolute;
                        bottom: 0;
                        left: 23.2vw;
                    }
                }
                .notes_list_box {
                    padding: 0 0.32rem;
                    .all_notes_box, .my_notes_box {
                        .van-pull-refresh {
                            min-height: 40vh;
                        }
                        .notes_item_box {
                            padding: 0.32rem 0;
                            border-bottom: 1px solid #E5E5E5;
                            .user_info_box {
                                display: flex;
                                align-items: center;
                                & > img {
                                    width: 0.8rem;
                                    height: 0.8rem;
                                    border-radius: 50%;
                                    margin-right: 0.2rem;
                                }
                                & > div {
                                    flex: 1;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    & > span {
                                        font-size: 0.24rem;
                                    }
                                    & > img {
                                        width: 0.26rem;
                                        height: 0.28rem;
                                    }
                                }
                            }
                            .notes_text {
                                padding-left: 1rem;
                                margin-top: 0.05rem;
                                margin-bottom: 0.28rem;
                                text-align: justify;
                                line-height: 0.4rem;
                                font-size: 0.26rem;
                            }
                            .date_div {
                                padding-left: 1rem;
                                display: flex;
                                justify-content: space-between;
                                & > p {
                                    line-height: 0.33rem;
                                    font-size: 0.24rem;
                                    color: #999;
                                }
                                // &>p:nth-of-type(1){

                                // }
                                & > p:nth-of-type(2) {
                                    display: flex;
                                    align-items: center;
                                    & > img {
                                        width: 0.28rem;
                                        height: 0.28rem;
                                        margin-right: 0.16rem;
                                    }
                                }
                            }
                        }
                        // .notes_item_box:nth-last-of-type(1){
                        //     border: none;
                        // }
                    }
                    // .my_notes_box {}
                }
            }
            .ques_warp {
              padding-top: 0.2rem;
              .quesItemBox {
                padding: 0 0.32rem;
                background: #fff;
                .quesItem {
                  padding: 0.28rem 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 0.28rem;
                  color: #303133;
                  &:not(:last-of-type) {
                    border-bottom: 0.01rem solid #E5E5E5;
                  }
                }
              }
              .tips {
                margin-top: 0.3rem;
                line-height: 0.34rem;
                color: #999999;
                font-size: 0.24rem;
                text-align: center;
                background: #F5F7FA;
              }
            }
        }
        .bottom_warp {
            & > div {
                position: fixed;
                bottom: 0;
                height: 1rem;
                background-color: #ffffff;
                width: 100vw;
                display: flex;
                align-items: center;
                border-top: 1px solid rgb(240, 238, 238);
                box-sizing: border-box;
            }
            .box1 {
                padding: 0.12rem 0.32rem;
                box-sizing: border-box;
                .van-button {
                    background: linear-gradient(180deg, #FF8170 0%, #D24747 100%);
                    border-radius: 0.1rem;
                    width: 100%;
                    height: 0.76rem;
                    font-size: 0.3rem;
                    border: none;
                    display: flex;
                    justify-content: center;
                    .van-button__text {
                        line-height: 0.76rem;
                        // &>span:nth-of-type(1){
                        //     font-size: 0.3rem;
                        // }
                        & > span:nth-of-type(2) {
                            margin-left: 0.12rem;
                            font-size: 0.26rem;
                            text-decoration: line-through;
                        }
                    }
                    &.openMember {
                        background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                        color: #FFE0AF;
                        border-radius: 0.1rem 0 0 0.1rem;
                    }
                    &.upgrade {
                        background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                        color: #FFFFFF;
                        border-radius: 0.1rem 0 0 0.1rem;
                    }
                    &.borderRadius {
                      border-radius: 0 0.1rem 0.1rem 0;
                    }
                }
            }
            .box2 {
                flex-direction: column;
                justify-content: center;
                & > img {
                    width: 0.44rem;
                    height: 0.44rem;
                    margin-bottom: 0.06rem;
                }
                & > span {
                    color: #409EFF;
                    font-size: 0.2rem;
                }
            }
            .box2:active {
                background-color: rgb(247, 247, 247);
            }
        }
        .pop_div {
            .isOpen_box {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-bottom: 0.2rem;
                .span_text {
                    color: #999;
                    font-size: 0.24rem;
                    margin-left: 0.16rem;
                }
            }
            .van-popup--bottom {
                padding: 0.24rem 0.32rem;
                box-sizing: border-box;
                .van-cell-group {
                    background-color: #fff;
                    border-radius: 0.04rem;
                    overflow: hidden;
                }
                .van-cell {
                    padding: 0.16rem;
                    background-color: #F5F7FA;
                    height: 2.62rem;
                }
                .van-field__control {
                    line-height: 0.45rem;
                    text-align: justify;
                }
                .van-button {
                    height: 0.76rem;
                    border-radius: 0.38rem;
                    width: 100%;
                    margin-top: 0.24rem;
                }
                .van-button {
                    background: linear-gradient(180deg, rgba(64, 199, 255, 1) 0%, rgba(64, 158, 255, 1) 100%);
                    height: 0.76rem;
                    border-radius: 0.38rem;
                    font-size: 0.3rem;
                    border: none;
                    display: flex;
                    justify-content: center;
                    .van-button__text {
                        line-height: 0.76rem;
                    }
                }
            }
        }
        .join_course_pop {
            .van-popup--center {
                background-color: transparent;
                .join_course_div {
                    & > div {
                        padding: 0.54rem 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 4.6rem;
                        background-color: rgb(255, 255, 255);
                        border-radius: 0.15rem;
                        .join_course_img {
                            width: 2.24rem;
                            height: 1.6rem;
                        }
                        & > p {
                            width: 2.8rem;
                            margin: 0.4rem 0;
                            text-align: center;
                            font-size: 0.28rem;
                            color: #333;
                            line-height: 0.4rem;
                        }
                        .van-button {
                            background: linear-gradient(180deg, rgba(64, 199, 255, 1) 0%, rgba(64, 158, 255, 1) 100%);
                            width: 3.48rem;
                            height: 0.6rem;
                            border-radius: 0.3rem;
                            font-size: 0.28rem;
                            border: none;
                            display: flex;
                            justify-content: center;
                            .van-button__text {
                                line-height: 0.6rem;
                            }
                        }
                    }
                    .close_img {
                        width: 0.6rem;
                        height: 0.6rem;
                        margin: 0 auto;
                        margin-top: 0.45rem;
                    }
                }
            }
        }
        .confirm_pop{
            .van-popup--center {
                background-color: transparent;
                .confirm_div {
                    padding-top: 0.54rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 4.6rem;
                    background-color: rgb(255, 255, 255);
                    border-radius: 0.15rem;
                    .confirm_img {
                        width: 2.24rem;
                        height: 1.6rem;
                    }
                    .confirm_tip {
                        width: 3rem;
                        margin: 0.4rem 0;
                        text-align: center;
                        font-size: 0.28rem;
                        color: #333;
                        line-height: 0.4rem;
                    }
                    .confirm_btn{
                        display: flex;
                        height: 0.9rem;
                        line-height: 0.9rem;
                        text-align: center;
                        border-top: 0.01rem solid #e5e5e5;
                        width: 4.6rem;
                        font-size: 0.32rem;
                        .cancelBtn{
                            flex: 1;
                            color: #666;
                        }
                        .confirmBtn{
                            flex: 1;
                            color: #409EFF ;
                            border-left: 0.01rem solid #e5e5e5;
                        }
                    }
                }
            }
        }
        .serviceqrurl_pop {
            .van-popup--center {
                width: 5.2rem;
                // height: 5.58rem;
                padding: 0.4rem 0;
                box-sizing: border-box;
                border-radius: 0.15rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                & > img {
                    width: 3.6rem;
                    height: 3.6rem;
                }
                .nama_text {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    margin-bottom: 0.2rem;
                }
                .tip_text {
                    font-size: 0.26rem;
                    line-height: 0.4rem;
                    margin-top: 0.2rem;
                }
            }
        }
        .shortcut_box {
            position: fixed;
            bottom: 1.8rem;
            right: 0.32rem;
            border-radius: 0.1rem;
            background: rgba(0, 0, 0, 0.45);
            & > div {
                margin: 0 0.16rem;
                border-bottom: 0.01rem solid #FFF;
                width: 0.56rem;
                padding: 0.12rem 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #FFF;
                & > img {
                    width: 0.4rem;
                    height: 0.4rem;
                    margin-bottom: 0.04rem;
                }
                & > span {
                    font-size: 0.18rem;
                    line-height: 0.25rem;
                }
            }
            & > div:nth-last-of-type(1) {
                border-bottom: none;
            }
        }
    }
</style>